import React from 'react';
import RadioButton from '../RadioButton/RadioButton';

import * as S from './SelectLanguage.styles';

const SelectLanguage = ({classes, handleOptionChange, currentLang}) => {
  return (
    <S.Container className={classes}>
      <S.Flag>
        <img src="https://assets-gos3.goibibo.com/myp_UAE_Flag-1673868146.png" alt="flag" />
      </S.Flag>
      <span className="font11 appendRight10">
        {currentLang === 'arabic' ? 'اختر اللغة' : 'Select Language'} :
      </span>
      <RadioButton
        defaultChecked
        name={'language'}
        id={'english'}
        classes="appendRight10"
        onChange={handleOptionChange}
        currenLanguage={currentLang}
      >
        <p className="latoBlack font11 blackText appendTop3">English</p>
      </RadioButton>
      <RadioButton
        name={'language'}
        id={'arabic'}
        classes="appendRight10 appendLeft10 "
        onChange={handleOptionChange}
        currenLanguage={currentLang}
      >
        <p className="latoBlack font11 blackText appendTop3">العربية</p>
      </RadioButton>
    </S.Container>
  );
};

export default SelectLanguage;
